import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import { boatDisplayText, inchesToFeet } from "legacy/helpers.es6"
import _ from "lodash"
import moment from "moment"
import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"

class MultiAssignmentView extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      assignments: this.props.selectedSpace.assignments || [],
      placeholders: this.props.selectedSpace.placeholders || [],
    }
    this.renderAssignment = this.renderAssignment.bind(this)
    this.renderPlaceHolder = this.renderPlaceHolder.bind(this)
    this.renderAll = this.renderAll.bind(this)
    this.renderHeader = this.renderHeader.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedSpace !== prevProps.selectedSpace) {
      this.setState({
        assignments: this.props.selectedSpace.assignments || [],
        placeholders: this.props.selectedSpace.placeholders || [],
      })
    }
  }

  renderAssignment(assignment) {
    return (
      <div
        className="w-full rounded bg-gray-100 p-3"
        key={assignment.reservation_id}
      >
        <div className="row-flex no-gutters">
          <div className="col-xs-6 mb-3">
            <div className="font-bold">Customer</div>
            {assignment.contact_name}
          </div>
          <div className="col-xs-6 mb-3">
            <div className="font-bold">Vessel</div>
            {boatDisplayText(
              assignment.boat_name,
              inchesToFeet(assignment.length_overall),
              assignment.boat_type
            )}
          </div>
          <div className="col-xs-6 mb-3">
            <div className="font-bold">Arrival</div>
            {moment(assignment.check_in_date, "YYYY-MM-DD").format(
              "dddd MM/DD/YYYY"
            )}
          </div>
          <div className="col-xs-6 mb-3">
            <div className="font-bold">Departure</div>
            {moment(assignment.check_out_date, "YYYY-MM-DD").format(
              "dddd MM/DD/YYYY"
            )}
          </div>
        </div>
        <LegacyButton
          type="secondary"
          className="w-full"
          onClick={() =>
            this.props.loadReservationForSidebar(
              assignment.reservation_id,
              this.props.selectedSpace
            )
          }
        >{`Reservation #${assignment.reservation_id}`}</LegacyButton>
      </div>
    )
  }

  renderPlaceHolder(placeholder) {
    return (
      <div className="w-full rounded bg-gray-100 p-3" key={placeholder.id}>
        <div className="row-flex no-gutters">
          <div className="col-xs-6 mb-3">
            <div className="font-bold">Start</div>
            {moment(placeholder.start_date, "YYYY-MM-DD").format(
              "dddd MM/DD/YYYY"
            )}
          </div>
          <div className="col-xs-6 mb-3">
            <div className="font-bold">End</div>
            {moment(placeholder.end_date, "YYYY-MM-DD").format(
              "dddd MM/DD/YYYY"
            )}
          </div>
          <div className="col-xs-6 mb-3">
            <div className="font-bold">LOA</div>
            {placeholder.length_overall}
          </div>
        </div>
        <LegacyButton
          type="secondary"
          className="w-full"
          onClick={() =>
            this.props.setPlaceholder(placeholder, this.props.selectedSpace)
          }
        >
          View Placeholder
        </LegacyButton>
      </div>
    )
  }

  renderAll() {
    const objects = _.concat(this.state.assignments, this.state.placeholders)
    return _.map(objects, (obj) => {
      if (obj.type === "assignment") {
        return this.renderAssignment(obj)
      } else {
        return this.renderPlaceHolder(obj)
      }
    })
  }

  renderHeader() {
    const hasPlaceholders = !_.isEmpty(this.state.placeholders) ? 1 : 0
    const hasAssignments = !_.isEmpty(this.state.assignments) ? 1 : 0
    const populatedTypes = hasAssignments + hasPlaceholders
    if (populatedTypes > 1) {
      return (
        <h4 className="mt-0 font-semibold">
          <i className="fa-kit fa-assignment mr-2" />
          {pluralize(
            "Assignment",
            this.state.assignments.length,
            true
          )} and <br />
          <i className="fa-solid fa-thumbtack mr-3" />
          {pluralize(
            "Placeholder",
            this.state.placeholders.length,
            true
          )} in {this.props.selectedSpace.name}
        </h4>
      )
    } else {
      return (
        <h4 className="mt-0 font-semibold">
          <i
            className={classNames("mr-2", {
              "fa-solid fa-thumbtack": hasPlaceholders,
              "fa-kit fa-assignment": hasAssignments,
            })}
          />
          {hasAssignments
            ? `${this.state.assignments.length} Assignments`
            : `${this.state.placeholders.length} Placeholders`}{" "}
          in {this.props.selectedSpace.name}
        </h4>
      )
    }
  }

  render() {
    return (
      <div className="flex h-screen w-full flex-col justify-start">
        <div
          className="space-y-2 overflow-y-auto"
          style={{ paddingBottom: 170 }}
        >
          {this.renderHeader()}
          <div
            className="grid gap-2"
            style={{
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            }}
          >
            {this.renderAll()}
          </div>
        </div>
      </div>
    )
  }
}

MultiAssignmentView.propTypes = {
  loadReservationForSidebar: PropTypes.func.isRequired,
  selectedSpace: PropTypes.object.isRequired,
  setPlaceholder: PropTypes.func.isRequired,
}

export default MultiAssignmentView
